const edicioncontenidomicrositio = {
   EditarContenidoDeMicrositio : 'SICPO/EditarContenido/EditarContenidoMIcrositio',
    EdicionDeContenidoMicrositio:'SICPO/EditarContenido/CancelarContenidoMIcrositio',
    ContenidosDeMicrositios:'SICPO/AltaDeContenido/GetContenidoMicrositio',
    ModificarOrdenContenidoMicrositio:'SICPO/AltaDeContenido/ModificarOrdenDeContenidosMicrositios'
}

export default edicioncontenidomicrositio;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SICPO/sistema/micrositioweb/edicioncontenidomicrositio/edicioncontenidomicrositio.js
// module id = null
// module chunks = 